import React from 'react';
import {Paper, Typography} from "@mui/material";


import ProcurementContainer from '../../procurement/containers/ProcurementContainer';
import ItemTransfersList from '../lists/itemTransfersList';
import CreateItemTransferComponent from '../component/CreateItemTransferComponent';


const ItemTransfersPage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Typography variant='h1' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
       Inventory Movement
      </Typography>
      <Paper sx={{my: 5}}>
        <CreateItemTransferComponent/>
      </Paper>
      <Paper sx={{my: 5}}>
        <ItemTransfersList/>
      </Paper>
    </ProcurementContainer>

  )
}

export default ItemTransfersPage